export const OPEN_MENU = "OPEN_MENU";
export const CLOSE_MENU = "CLOSE_MENU";

export const SET_ACTIVE_TOP_LABEL = "SET_ACTIVE_TOP_LABEL";

export const OPEN_TOP_MENU = "OPEN_TOP_MENU";
export const CLOSE_TOP_MENU = "CLOSE_TOP_MENU";

export const OPEN_SEARCH = "OPEN_SEARCH";
export const CLOSE_SEARCH = "CLOSE_SEARCH";

export const SET_BANNER_STATE = "SET_BANNER_STATE";

export const TOGGLE_HEADER = "TOGGLE_HEADER";

export const SET_HEADER_STATE = "SET_HEADER_STATE";
